// extracted by mini-css-extract-plugin
export default {"containerStyle":"GrowBusiness_containerStyle__eotSa","content":"GrowBusiness_content__RQXcJ"};